import { IBox } from '~/client/src/shared/map/exportLabelTypes'

// The credits live in mapbox's DOM controls, which a GL capture never sees, and they are mandatory
// (see mapAttributionRule). Drawn as geometry: rasterizing mapbox's own controls is what tainted
// the canvas in the first place.

// Verbatim from mapbox-gl.css's `a.mapboxgl-ctrl-logo` background, on its own 88x23 grid.
const WORDMARK_VIEWBOX = { width: 88, height: 23 }
// The mark's outline is a disc behind the glyph, not a stroke along it.
const WORDMARK_DISC = { cx: 11.5, cy: 11.5, r: 9.25 }
const WORDMARK_MARK_PATH =
  'M11.5 2.25c5.105 0 9.25 4.145 9.25 9.25s-4.145 9.25-9.25 9.25-9.25-4.145-9.25-9.25 4.145-9.25 9.25-9.25zM6.997 15.983c-.051-.338-.828-5.802 2.233-8.873a4.395 4.395 0 013.13-1.28c1.27 0 2.49.51 3.39 1.42.91.9 1.42 2.12 1.42 3.39 0 1.18-.449 2.301-1.28 3.13C12.72 16.93 7 16 7 16l-.003-.017zM15.3 10.5l-2 .8-.8 2-.8-2-2-.8 2-.8.8-2 .8 2 2 .8z'
const WORDMARK_TEXT_PATH =
  'M50.63 8c.13 0 .23.1.23.23V9c.7-.76 1.7-1.18 2.73-1.18 2.17 0 3.95 1.85 3.95 4.17s-1.77 4.19-3.94 4.19c-1.04 0-2.03-.43-2.74-1.18v3.77c0 .13-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V8.23c0-.12.1-.23.23-.23h1.4zm-3.86.01c.01 0 .01 0 .01-.01.13 0 .22.1.22.22v7.55c0 .12-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V15c-.7.76-1.69 1.19-2.73 1.19-2.17 0-3.94-1.87-3.94-4.19 0-2.32 1.77-4.19 3.94-4.19 1.03 0 2.02.43 2.73 1.18v-.75c0-.12.1-.23.23-.23h1.4zm26.375-.19a4.24 4.24 0 00-4.16 3.29c-.13.59-.13 1.19 0 1.77a4.233 4.233 0 004.17 3.3c2.35 0 4.26-1.87 4.26-4.19 0-2.32-1.9-4.17-4.27-4.17zM60.63 5c.13 0 .23.1.23.23v3.76c.7-.76 1.7-1.18 2.73-1.18 1.88 0 3.45 1.4 3.84 3.28.13.59.13 1.2 0 1.8-.39 1.88-1.96 3.29-3.84 3.29-1.03 0-2.02-.43-2.73-1.18v.77c0 .12-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V5.23c0-.12.1-.23.23-.23h1.4zm-34 11h-1.4c-.13 0-.23-.11-.23-.23V8.22c.01-.13.1-.22.23-.22h1.4c.13 0 .22.11.23.22v.68c.5-.68 1.3-1.09 2.16-1.1h.03c1.09 0 2.09.6 2.6 1.55.45-.95 1.4-1.55 2.44-1.56 1.62 0 2.93 1.25 2.9 2.78l.03 5.2c0 .13-.1.23-.23.23h-1.41c-.13 0-.23-.11-.23-.23v-4.59c0-.98-.74-1.71-1.62-1.71-.8 0-1.46.7-1.59 1.62l.01 4.68c0 .13-.11.23-.23.23h-1.41c-.13 0-.23-.11-.23-.23v-4.59c0-.98-.74-1.71-1.62-1.71-.85 0-1.54.79-1.6 1.8v4.5c0 .13-.1.23-.23.23zm53.615 0h-1.61c-.04 0-.08-.01-.12-.03-.09-.06-.13-.19-.06-.28l2.43-3.71-2.39-3.65a.213.213 0 01-.03-.12c0-.12.09-.21.21-.21h1.61c.13 0 .24.06.3.17l1.41 2.37 1.4-2.37a.34.34 0 01.3-.17h1.6c.04 0 .08.01.12.03.09.06.13.19.06.28l-2.37 3.65 2.43 3.7c0 .05.01.09.01.13 0 .12-.09.21-.21.21h-1.61c-.13 0-.24-.06-.3-.17l-1.44-2.42-1.44 2.42a.34.34 0 01-.3.17zm-7.12-1.49c-1.33 0-2.42-1.12-2.42-2.51 0-1.39 1.08-2.52 2.42-2.52 1.33 0 2.42 1.12 2.42 2.51 0 1.39-1.08 2.51-2.42 2.52zm-19.865 0c-1.32 0-2.39-1.11-2.42-2.48v-.07c.02-1.38 1.09-2.49 2.4-2.49 1.32 0 2.41 1.12 2.41 2.51 0 1.39-1.07 2.52-2.39 2.53zm-8.11-2.48c-.01 1.37-1.09 2.47-2.41 2.47s-2.42-1.12-2.42-2.51c0-1.39 1.08-2.52 2.4-2.52 1.33 0 2.39 1.11 2.41 2.48l.02.08zm18.12 2.47c-1.32 0-2.39-1.11-2.41-2.48v-.06c.02-1.38 1.09-2.48 2.41-2.48s2.42 1.12 2.42 2.51c0 1.39-1.09 2.51-2.42 2.51z'

const CREDIT_TEXT = '© Mapbox © OpenStreetMap'
// A third rightsholder that mapbox's text-attribution terms name explicitly. The live badge reads
// it off the style's sources; a stamped image cannot.
const SATELLITE_CREDIT = '© Maxar'
const CREDIT_FONT_STACK = '"Helvetica Neue", Arial, Helvetica, sans-serif'

// Sized against the IMAGE, not the screen: at screen size the wordmark filled a fifth of a 400px
// shot. Floored because the attribution still has to be legible.
const WORDMARK_WIDTH_RATIO = 0.14
const WORDMARK_MIN_WIDTH_PX = 44
const CREDIT_FONT_RATIO = 0.022
const CREDIT_FONT_MIN_PX = 7
// What the halo was tuned against, so it stays in proportion as the credits shrink.
const CREDIT_FONT_BASE_PX = 10

const INSET_PX = 6
// The credit is drawn in whichever sans the device has, so its box is reserved, not measured:
// Helvetica's widths put the longest one, the satellite credit, at 17em; the rest is for a wider
// fallback face.
const CREDIT_TEXT_RESERVE_EM = 19
const CREDIT_LINE_HEIGHT_EM = 1.2
const HALO_WIDTH_PX = 3
const HALO_COLOR = 'rgba(0, 0, 0, 0.3)'
const INK_COLOR = 'rgba(255, 255, 255, 0.9)'

export interface ICreditsLayout {
  wordmarkWidth: number
  fontPx: number
  haloPx: number
}

export function creditsLayout(widthCss: number): ICreditsLayout {
  const fontPx = Math.max(CREDIT_FONT_MIN_PX, widthCss * CREDIT_FONT_RATIO)
  return {
    wordmarkWidth: Math.min(
      WORDMARK_VIEWBOX.width,
      Math.max(WORDMARK_MIN_WIDTH_PX, widthCss * WORDMARK_WIDTH_RATIO),
    ),
    fontPx,
    haloPx: HALO_WIDTH_PX * (fontPx / CREDIT_FONT_BASE_PX),
  }
}

// Map exports carry mapbox's own control sizes on every paper, quality and format, so the
// credits read the same on every file; `scale` only grows them for a sheet read from further
// away, the wordmark uniformly, as mapbox allows it to be resized but never restyled.
export const exportCreditsLayout = (scale: number): ICreditsLayout => ({
  wordmarkWidth: WORDMARK_VIEWBOX.width * scale,
  fontPx: 12 * scale,
  haloPx: 2 * scale,
})

/** The export credits' corners in layout px, from each one's outer edge to the map's edges. */
export function exportCreditsBoxes(
  width: number,
  height: number,
  scale: number,
): IBox[] {
  const { wordmarkWidth, fontPx, haloPx } = exportCreditsLayout(scale)
  const markScale = wordmarkWidth / WORDMARK_VIEWBOX.width
  const wordmark = {
    width: INSET_PX + wordmarkWidth + HALO_WIDTH_PX * markScale,
    height:
      INSET_PX +
      WORDMARK_VIEWBOX.height * markScale +
      HALO_WIDTH_PX * markScale,
  }
  const credit = {
    width: INSET_PX + fontPx * CREDIT_TEXT_RESERVE_EM + haloPx,
    height: INSET_PX + fontPx * CREDIT_LINE_HEIGHT_EM + haloPx,
  }
  return [
    { x: 0, y: height - wordmark.height, ...wordmark },
    { x: width - credit.width, y: height - credit.height, ...credit },
  ]
}

/** `scale` is the capture's pixel density, turning the CSS-pixel layout above into device px. */
export function drawMapCredits(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  scale: number,
  isSatellite?: boolean,
  layout: ICreditsLayout = creditsLayout(scale > 0 ? width / scale : width),
): void {
  const { wordmarkWidth, fontPx, haloPx } = layout
  const markScale = (wordmarkWidth / WORDMARK_VIEWBOX.width) * scale
  const inset = INSET_PX * scale

  ctx.save()
  ctx.lineJoin = 'round'
  ctx.strokeStyle = HALO_COLOR
  ctx.fillStyle = INK_COLOR

  ctx.save()
  ctx.translate(inset, height - inset - WORDMARK_VIEWBOX.height * markScale)
  ctx.scale(markScale, markScale)
  // viewBox units, so the outline keeps its weight as the mark scales.
  ctx.lineWidth = HALO_WIDTH_PX
  const disc = new Path2D()
  disc.arc(WORDMARK_DISC.cx, WORDMARK_DISC.cy, WORDMARK_DISC.r, 0, 2 * Math.PI)
  ctx.fillStyle = HALO_COLOR
  ctx.fill(disc)
  ctx.stroke(disc)
  ctx.fillStyle = INK_COLOR
  ctx.fill(new Path2D(WORDMARK_MARK_PATH), 'evenodd')
  // For the lettering the halo IS a stroke, and it only ever shows outside the glyphs.
  const text = new Path2D(WORDMARK_TEXT_PATH)
  ctx.stroke(text)
  ctx.fill(text, 'evenodd')
  ctx.restore()

  const credit = isSatellite
    ? `${CREDIT_TEXT} ${SATELLITE_CREDIT}`
    : CREDIT_TEXT
  ctx.font = `${fontPx * scale}px ${CREDIT_FONT_STACK}`
  ctx.textAlign = 'right'
  ctx.textBaseline = 'bottom'
  ctx.lineWidth = haloPx * scale
  ctx.strokeText(credit, width - inset, height - inset)
  ctx.fillText(credit, width - inset, height - inset)

  ctx.restore()
}
